export const IGetCacheUseCaseType = Symbol('IGetCacheUseCase');
